import { render, staticRenderFns } from "./Livraison.vue?vue&type=template&id=64018c72"
import script from "./Livraison.vue?vue&type=script&lang=js"
export * from "./Livraison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64018c72')) {
      api.createRecord('64018c72', component.options)
    } else {
      api.reload('64018c72', component.options)
    }
    module.hot.accept("./Livraison.vue?vue&type=template&id=64018c72", function () {
      api.rerender('64018c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Livraison.vue"
export default component.exports